import { cacheFirstConfig, CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';

import { ApiResource } from '@/core/models/ApiResource.interface';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { PerformanceCode } from './performance-code.interface';

class PerformanceCodeService {
   async getPerformanceCodes(query: LocationQuery) {
      return await http
         .get<PaginatedResponse<PerformanceCode>>(`/performance-codes`, { ...cacheFirstConfig, params: { ...query } })
         .then((response) => response.data);
   }

   async getPerfromanceCode(performanceCodeId: number) {
      return await http.get<ApiResource<PerformanceCode>>(`/performance-codes/${performanceCodeId}`).then((response) => response.data);
   }

   async getPainterPerformanceCodes() {
      return await http.get(`/paint-performance-options`, cacheFirstConfig).then((response) => response.data);
   }

   async getFeePerformanceCodes(customerId: number, query: LocationQuery) {
      return await http
         .get(`/customers/${customerId}/contract-fee-codes`, { params: { ...query }, cancelable: false } as CustomAxiosRequestConfig)
         .then((response) => response.data);
   }
}

export default new PerformanceCodeService();
